/* eslint-disable array-callback-return */
/**
 * 提供兼容node和browser环境的addURLParameters和removeURLParameters工具方法
 */
import { appConfigInstance } from '../config/index';
import { getHost } from '../location/index';
// hash分隔符
var HASH_SYMBOL = '#';
// search分隔符
var SEARCH_SYMBOL = '?';
// query分隔符
var QUERY_SYMBOL = '&';
/**
 * 内部方法： 处理不带hash url下删除参数的case,
 * @param url
 * @param params
 * @returns
 */
function removeURLParametersWithoutHash(url, params) {
    var _a;
    var urlParts = url.split(SEARCH_SYMBOL);
    var querys = (_a = urlParts[1]) === null || _a === void 0 ? void 0 : _a.split(QUERY_SYMBOL);
    if (!querys)
        return url;
    var querysAfterRemoved = querys;
    // 遍历querys，是否存在param， 这里全找了遍，避免入url上有重复params或paramValues里有重复params
    params.forEach(function (param) {
        querys.forEach(function (queryParam) {
            // 找到一处，删一处，同一个key出现多次，全清.   此处改为 index === 0, 全匹配
            if (queryParam.startsWith("".concat(param, "="))) {
                var index = querysAfterRemoved.indexOf(queryParam);
                querysAfterRemoved.splice(index, 1);
            }
        });
    });
    // 删光了，直接返回没有search部分
    if (querysAfterRemoved.length === 0) {
        return urlParts[0];
    }
    // 还有参数，重组url
    urlParts[1] = querysAfterRemoved.join(QUERY_SYMBOL);
    return urlParts.join(SEARCH_SYMBOL);
}
/**
 * 检查带search的url上是否有param，如果有更新，没有就添加
 * @param url // 内部方法，一定是有search的情况
 * @param param
 * @param value
 * @returns
 */
function checkExistParamAddOrUpdate(url, param, value) {
    var urlParts = url.split(SEARCH_SYMBOL);
    var querys = urlParts[1].split(QUERY_SYMBOL);
    // 默认param不存在
    var notParam = true;
    // 存放querys的map，用map为了去重
    var querysMap = new Map();
    querys.forEach(function (query) {
        var paramValue = query.split('=');
        querysMap.set(paramValue[0], paramValue[1]);
    });
    // 打有没有当前要add的param，有直接更新
    querys.some(function (query) {
        if (query.startsWith("".concat(param, "="))) {
            querysMap.set(param, value);
            notParam = false;
        }
    });
    // 没有直接拼
    if (notParam) {
        querysMap.set(param, value);
    }
    // 拼新url并返回
    var tempQueryKeys = [];
    querysMap.forEach(function (val, key) {
        var query = "".concat(key, "=").concat(val);
        tempQueryKeys.push(query);
    });
    urlParts[1] = tempQueryKeys.join(QUERY_SYMBOL);
    return urlParts.join(SEARCH_SYMBOL);
}
/**
 * 内部方法： 处理不带hash url下删除参数的case,
 * @param url
 * @param paramValues
 * @returns
 */
function addURLParametersWithoutHash(url, paramValues) {
    // 有search 逐个param处理query
    if (url.includes(SEARCH_SYMBOL)) {
        var tempUrl_1 = url;
        Object.keys(paramValues).map(function (param) {
            tempUrl_1 = checkExistParamAddOrUpdate(tempUrl_1, param, paramValues[param]);
        });
        return tempUrl_1;
    }
    // 没有search， 直接拼上即可
    var search = Object.keys(paramValues).map(function (param) { return "".concat(param, "=").concat(paramValues[param]); })
        .join(QUERY_SYMBOL);
    return "".concat(url, "?").concat(search);
}
/**
 * 删除url上指定参数
 * @param url 要处理的url
 * @param params 可变参数, 多个params可并排写,  或直接传数组进来
 * @returns string
 */
export function removeURLParameters(url) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    var urlParts = url.split(SEARCH_SYMBOL);
    // 没有search部分直接返回
    if (urlParts.length < 2 || params.length === 0) {
        return url;
    }
    // 有hash的情况下，先把hash给保存下来，处理完非hash部分再给拼回去
    if (url.includes(HASH_SYMBOL)) {
        var hashParts = url.split(HASH_SYMBOL);
        hashParts[0] = removeURLParametersWithoutHash(hashParts[0], params);
        return hashParts.join(HASH_SYMBOL);
    }
    // 处理非hash case
    return removeURLParametersWithoutHash(url, params);
}
/**
 * 为给定url 添加 或 更新 一组参数
 * 拼参数的时候会按参数字典序排序
 * @param url
 * @param paramValues<string, string | number>的键值对
 * @returns 拼好的url
 */
export function addURLParameters(url, paramValues) {
    if (Object.keys(paramValues).length === 0) {
        return url;
    }
    // 有hash的情况下，先把hash给保存下来，处理完非hash部分再给拼回去
    if (url.includes(HASH_SYMBOL)) {
        var urlParts = url.split(HASH_SYMBOL);
        urlParts[0] = addURLParametersWithoutHash(urlParts[0], paramValues);
        return urlParts.join(HASH_SYMBOL);
    }
    // 处理非hash case
    return addURLParametersWithoutHash(url, paramValues);
}
/**
 * 查询 url 中的参数
 * @param {string} paramKey 参数名
 */
export function getURLParameter(paramKey, url) {
    var search = url ? new URL(url).search : window.location.search;
    var urlParams = new URLSearchParams(search);
    return urlParams.get(paramKey);
}
/**
 * 判断url是否有域名
 * '/sheet/xxx'              => false
 * 'xxxxx.com/sheet/xxx'     => true
 * '//xxxx.com/sheet/xxx'    => true
 * 'https://xxxx.com/shee/x' => true
 * @param url string
 * @returns boolean
 */
export function hasDomain(url) {
    var _a;
    if (!url) {
        return false;
    }
    // 如果url是//开头，则默认有域名
    if (url.startsWith('//')) {
        return true;
    }
    // 如果url包含 :// 则默认有域名
    if (url.includes('://')) {
        return true;
    }
    // 这里筛选出xxx.com/xxx/xxx这类url
    if (!url.startsWith('/')) {
        var splitArr = url.split('/');
        // 如果有“.”则说明url有域名
        if ((_a = splitArr[0]) === null || _a === void 0 ? void 0 : _a.includes('.')) {
            return true;
        }
    }
    return false;
}
/**
 * @description 给url加上域名
 * @param {string} url
 * @returns {*}
 */
export var addDomainForUrl = function (url) {
    if (!url) {
        return url;
    }
    if (hasDomain(url)) {
        return url;
    }
    // 拿当前访问的域名加到url中
    var domainName = appConfigInstance.getConfig('runtime.domainName');
    if (!domainName) {
        domainName = getHost();
    }
    var formatUrl = url.startsWith('/') ? url : "/".concat(url);
    return "//".concat(domainName).concat(formatUrl);
};
